export const muiTheme = {
    palette: {
        text: {
            primary: '#333333',
        },
    },
    typography: {
        fontFamily: 'Open Sans,Noto Sans JP,PingFang SC,メイリオ,Meiryo,ＭＳ Ｐゴシック,MS PGothic,Osaka,sans-serif',
        fontWeightRegular: 350,
    },
    components: {
        MuiOutlinedInput: {
            defaultProps: {
                sx: {
                    fontSize: '14px',
                },
            },
        },
    },
}
